export function Differentials() {
  const differentials = [
    {
      icon: 'ri-heart-pulse-line',
      title: 'Olhar Humano e Técnico ao Mesmo Tempo',
      description: 'Você não é apenas um caso clínico. Aqui, ciência e empatia caminham juntas para uma transformação real e profunda.'
    },
    {
      icon: 'ri-lightbulb-flash-line',
      title: 'Sessões Profundas que Realmente Despertam',
      description: 'Nada de conversas superficiais. Cada encontro é uma jornada de autoconhecimento que toca o que realmente importa.'
    },
    {
      icon: 'ri-mind-map',
      title: 'Integração Sistêmica e Cognitivo-Comportamental',
      description: 'Trabalho com mente, corpo e relações de forma integrada. Você se transforma por completo, não apenas em partes isoladas.'
    },
    {
      icon: 'ri-message-2-line',
      title: 'Comunicação Clara, Transparente e Realista',
      description: 'Sem rodeios ou promessas vazias. Você sempre saberá onde está, para onde vai e o que esperar do processo.'
    },
    {
      icon: 'ri-file-edit-line',
      title: 'Materiais e Exercícios Personalizados',
      description: 'Ferramentas criadas especialmente para você, dentro e fora da sessão, acelerando sua evolução de forma prática.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Acompanhamento Contínuo e Cuidadoso',
      description: 'Suporte dentro e fora das sessões, incluindo finais de semana. Você nunca estará sozinho nos momentos difíceis.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Espaço Seguro, Sem Críticas, Sem Pressa',
      description: 'Aqui não há julgamentos, rótulos ou pressão. Você pode ser quem realmente é, no seu tempo, com total liberdade.'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Terapia Voltada Para Autonomia',
      description: 'Meu objetivo é que você se torne independente, capaz de lidar com seus desafios com confiança e clareza.'
    },
    {
      icon: 'ri-eye-line',
      title: 'Leitura Emocional Refinada',
      description: 'Percebo além das palavras. Entendo o que você sente mesmo quando não consegue expressar, acelerando sua transformação.'
    },
    {
      icon: 'ri-user-star-line',
      title: 'Sem Fórmulas Prontas — Você é Único',
      description: 'Cada pessoa é conduzida de forma única e personalizada. Sua jornada é sua, e será respeitada em cada detalhe.'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white to-[#F0F9F7]">
      <div className="max-w-7xl mx-auto px-6 lg:px-20">
        <div className="text-center mb-16">
          <span className="inline-block bg-[#E0F2EF] text-[#7DD3C0] text-sm font-medium px-6 py-2 rounded-full mb-6">
            O Que Me Torna Diferente
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#2C2C2C] mb-6" style={{ fontFamily: 'Inter, sans-serif' }}>
            Meus Diferenciais
          </h2>
          <p className="text-lg text-[#6B6B6B] max-w-3xl mx-auto leading-relaxed">
            Não é apenas terapia. É um processo transformador, profundo e personalizado, 
            pensado para você alcançar resultados reais em todas as áreas da sua vida.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 mb-12">
          {differentials.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-md hover:shadow-2xl transition-all duration-500 border border-transparent hover:border-[#7DD3C0] group cursor-pointer"
            >
              <div className="flex items-start gap-5">
                <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-[#7DD3C0] to-[#6BC4B0] rounded-xl flex-shrink-0 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                  <i className={`${item.icon} text-2xl text-white`}></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-[#2C2C2C] mb-3 leading-snug">
                    {item.title}
                  </h3>
                  <p className="text-[#6B6B6B] leading-relaxed text-[15px]">
                    {item.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-[#7DD3C0] to-[#6BC4B0] rounded-3xl p-12 text-center shadow-2xl">
          <h3 className="text-3xl lg:text-4xl font-bold text-white mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>
            Pronto Para Começar Sua Transformação?
          </h3>
          <p className="text-white/90 text-lg mb-8 max-w-2xl mx-auto">
            Cada sessão é um passo em direção à versão mais forte, equilibrada e feliz de você. 
            Não espere mais para cuidar do que realmente importa.
          </p>
          <a
            href="https://wa.me/5511941652251"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-white text-[#7DD3C0] px-10 py-5 rounded-full font-bold text-lg hover:bg-[#2C2C2C] hover:text-white transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            Agende Sua Primeira Sessão
          </a>
        </div>
      </div>
    </section>
  );
}